import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Petsitter, CertificateService } from 'npx-family-happy-common';
import { PetsitterService } from '../petsitter-service/petsitter-service.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cv-petsitter-template',
  templateUrl: './cv-petsitter-template.component.html',
  styleUrls: ['./cv-petsitter-template.component.scss'],
  standalone:true,
  imports:[CommonModule]
})
export class CvPetsitterTemplateComponent {
  @Input() set petsitter(petsitter: Petsitter) {
    this._petsitter = petsitter;
    if (this._petsitter !== undefined) {
      this.showReference = this._petsitter.reference && ((this._petsitter.reference.f_surname !== null && this._petsitter.reference.f_surname !== '') ||
        (this._petsitter.reference.f_second_surname !== null && this._petsitter.reference.f_second_surname !== ''));
      this.certificates = this._petsitter.certificates.petsitterCertificateList.filter(item => item !== '').slice(0, 3);
      this.initAvailabilieties();
      this.initAttitude();
      this.initSubjects();
    }
  };
  @Input() isProduction = false;
  @Input() mailServiceURL = '';
  @Input() showModal = false;

  @Input() set generatePages(value: boolean) {
    if (value) {
      this.calcPages();
    } else {
      this.generationDone = false;
    }
  }

  @Input() currentPage!: number;
  availabilities: string[] = [];
  homeworkSubjects: string[] = [];
  showReference = false;
  attitude: string = '';
  _petsitter!: Petsitter;
  pages: string[] = [];
  generationDone: boolean = false;
  previewMode: boolean = true;
  certificates: string[] = [];
  @Output() sendPages = new EventEmitter<number>();

  constructor(public sanitizer: DomSanitizer, private certificateService: CertificateService, private petsitterService: PetsitterService) { }


  calcPages() {
    this.pages = [];
    let rightColumn = document.getElementById('right-column') as HTMLDivElement;
    let elY = rightColumn.getBoundingClientRect().top;
    let aboutMe = document.getElementById('about-me-section') as HTMLDivElement;
    let experienceSection = document.getElementById('experience-section') as HTMLDivElement;
    let reference = document.getElementById('reference');
    let currentPage = 0;
    this.pages[0] += `<div class="experience-range">`;
    this.pages[currentPage] += '</div></div>';
    if (reference && this.showReference) {
      this.pages[currentPage] += reference.outerHTML;
    }
    this.generationDone = true;
    this.sendPages.emit(this.pages.length);
  }

  generatePDF() {
    const template = document.getElementById('cv-page-container') as HTMLElement;
  }

  private initAvailabilieties() {
    this.availabilities = [];
  }

  private initAttitude() {
    this.attitude = '';
    if (this._petsitter.rating.attitude === 'Facilitatore') {
      this.attitude = `Questo profilo è tendenzialmente interessato a comportamenti armoniosi verso le persone e l’ambiente che lo circonda. Risulta essere una persona che ha fiducia in sé stessa, con una buona capacità di riflessione. Fa tesoro delle proprie esperienze per migliorare. Ha buona capacità a stringere legami, anche profondi, con le persone con cui viene in contatto. Ha un approccio tendenzialmente pacato e presenta una spiccata abilità nel trovare il proprio equilibrio.`;
    }
    if (this._petsitter.rating.attitude === 'Disciplina') {
      this.attitude = `Questo profilo è ottimista e consapevole delle proprie capacità. È una persona comprensiva ed equilibrata. Esprime un forte senso di responsabilità e dovere ed è caratterizzato da una marcata propensione al fare “bene” e alla perseveranza. Predilige ambienti organizzati e strutturati.`;
    }
    if (this._petsitter.rating.attitude === 'Accondiscendente') {
      this.attitude = `Questo profilo è caratterizzato principalmente dall’ottimismo. Ha fiducia nel futuro, nel prossimo e nel mondo in generale. E’ una persona dinamica e fantasiosa. E’ mossa prevalentemente da nobili sentimenti, non ama il conflitto né i pensieri negativi. Persona flessibile, aperta ai cambiamenti, affronta gli imprevisti con buon entusiasmo.`;
    }
    if (this._petsitter.rating.attitude === 'Esecutore') {
      this.attitude = `Questo profilo ama aiutare gli altri. E’ saggio ma anche prudente e accetta favorevolmente di essere guidato soprattutto quando si trova ad affrontare una situazione per la prima volta. E’ una persona altruista che prende a cuore la salute degli altri. E’ sensibile ed è attento a non sovrastare gli altri.`;
    }
    if (this.attitude === '') {
      this.attitude = `Questo profilo non ha ancora svolto il test psicoattitudinale.`;
    }
  }

  private initSubjects() {
    this.homeworkSubjects = [];
  }

  taskCheck(cluster: number, task: string) {
    switch (cluster) {
      case 1:
        return this._petsitter.exp.cluster1.tasks1.split('-').some(task1 => task1 === task);

      case 2:
        return this._petsitter.exp.cluster2.tasks2.split('-').some(task2 => task2 === task);

      case 3:
        return this._petsitter.exp.cluster3.tasks3.split('-').some(task3 => task3 === task);

      default:
        return false;
    }
  }

  changePage(forward: boolean) {
    if (forward && this.currentPage < this.pages.length - 1) {
      this.currentPage++;
    }
    if (!forward && this.currentPage > 0) {
      this.currentPage--;
    }
  }

  sendCV() {
    this.certificateService.sendCVByMailToPetsitter(this._petsitter, this.isProduction, this.mailServiceURL, this.showModal);
  }

  checkCategory(category: 'catHealing' | 'catHosting' | 'dogHosting' | 'dogHealing' , flag: string) {
    const categoryData = this._petsitter.avail[category];
    if (!categoryData || categoryData === '') {
      return false;
    }
    const flags = categoryData.split('-');

    return flags.some(item => item === flag);
  }
}
